var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoaderTwoMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 444,
    height: 1043,
    viewBox: "0 0 444 1043",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "loaderTwoMobile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 4",
    filter: "url(#filter0_b_128_27)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 630,
    width: 351,
    height: 89,
    rx: 4,
    fill: "#3B4856",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 97",
    filter: "url(#filter1_b_128_27)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 735,
    width: 351,
    height: 89,
    rx: 4,
    fill: "#3B4856",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 101",
    filter: "url(#filter2_b_128_27)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 841,
    width: 351,
    height: 89,
    rx: 4,
    fill: "#3B4856",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 95",
    x: 46,
    y: 564,
    width: 351,
    height: 29,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 90",
    x: 72,
    y: 659,
    width: 89,
    height: 27,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 98",
    x: 72,
    y: 764,
    width: 89,
    height: 28,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 102",
    x: 72,
    y: 871,
    width: 89,
    height: 27,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 96",
    x: 281,
    y: 659,
    width: 89,
    height: 27,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 99",
    x: 281,
    y: 764,
    width: 89,
    height: 28,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 103",
    x: 281,
    y: 871,
    width: 89,
    height: 27,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 92",
    x: 198,
    y: 652,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 100",
    x: 198,
    y: 758,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 104",
    x: 199,
    y: 862,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 108",
    x: 339,
    y: 315,
    width: 39,
    height: 36,
    rx: 18,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 76",
    x: 46,
    y: 198,
    width: 351,
    height: 80,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 106",
    x: 93,
    y: 315,
    width: 111,
    height: 36,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 107",
    x: 216,
    y: 315,
    width: 111,
    height: 36,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 105",
    x: 133,
    y: 112,
    width: 178,
    height: 59,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 78",
    x: 77,
    y: 415,
    width: 111,
    height: 28,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 80",
    x: 255,
    y: 415,
    width: 111,
    height: 28,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 79",
    x: 77,
    y: 453,
    width: 111,
    height: 28,
    rx: 4,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 81",
    x: 255,
    y: 453,
    width: 111,
    height: 28,
    rx: 4,
    fill: "#E5E5E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_128_27",
    x: 40,
    y: 624,
    width: 363,
    height: 101,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_128_27"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_128_27",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_128_27",
    x: 40,
    y: 729,
    width: 363,
    height: 101,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_128_27"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_128_27",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_128_27",
    x: 40,
    y: 835,
    width: 363,
    height: 101,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_128_27"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_128_27",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderTwoMobile);
export default __webpack_public_path__ + "static/media/loader-two-mobile.03849930ee776eb5f6d6eb9aee84c7dc.svg";
export { ForwardRef as ReactComponent };